export default {
  A: 'ALS',
  B: 'BLS',
  H: 'Heli',
  N: 'NT',
};
